import React, { useState, useEffect, useRef, useMemo } from "react";
import "./faan.scss";
import { alertActions } from "../../_actions";
import { appConstants } from "../../_constants";
import { connect } from "react-redux";
import { Row, Col, Button } from "reactstrap";
import { PaymentHistoryTable } from "./record";
import PartPaymentModal from "./partial-payment-modal";
import PaymentSummary from "./payment-summary-modal";
import { externalPaymentService } from "../../_services/externalPayment.service";
import { store } from "react-notifications-component";
import PaymentOptionCard from "./payment-option-card";

let source;

const InvoiceDetails = ({
  invoiceAmount,
  invoiceNumber,
  rrr,
  revenue,
  agencyName,
  location,
  phoneNumber,
  email,
  amountPaid,
  outstanding,
  paymentHistory,
  dispatch,
  agencyId,
  billerUrl,
  merchantId,
  hash,
  responseUrl,
  numberOfPayment,
  minimumPartPayment,
  percentagePartPayment,
  deleted,
  status,
  searchInvoiceReference,
  enablePartialPayment,
  disableRevenuePayment,
  revenuePaymentGateway,
}) => {
  const [showPaymentHistory, setShowPaymentHistory] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rrrDetails, setRRRDetails] = useState(null);
  const [isPaymentModal, setIsPaymentModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const invoiceLocal = localStorage.getItem("Invoice Number");
  const formRef = useRef(null);
  const savedInvoice = localStorage.getItem("Invoice Details");
  const [selectedGatewayId, setSelectedGatewayId] = useState(null);

  const gateways = useMemo(() => {
    const list = revenuePaymentGateway?.gateways;
    if (!Array.isArray(list)) return [];
    return list
      .filter(Boolean)
      .map((g) => ({
        paymentGateway: String(g.paymentGateway || "").trim(),
        revenuePaymentGatewayId: g.revenuePaymentGatewayId,
        logoURL: g.logoURL || null, 
      }))
      .filter((g) => g.paymentGateway.toLowerCase() === "revops" && g.revenuePaymentGatewayId != null);
  }, [revenuePaymentGateway]);

  const selectedGateway = useMemo(() => {
    if (!selectedGatewayId) return null;
    return (
      gateways.find((g) => g.revenuePaymentGatewayId === selectedGatewayId) ||
      null
    );
  }, [selectedGatewayId, gateways]);

  useEffect(() => {
    if (!selectedGatewayId) return;
    const stillExists = gateways.some(
      (g) => g.revenuePaymentGatewayId === selectedGatewayId
    );
    if (!stillExists) setSelectedGatewayId(null);
  }, [gateways, selectedGatewayId]);

  const searchInvoiceRRR = async () => {
    let payload = {
      invNum: invoiceLocal,
    };

    setIsLoading(true);
    dispatch(alertActions.startRequest());

    try {
      const res = await externalPaymentService.getRRR(payload);
      dispatch(alertActions.stopRequest());

      let response = res.response;
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        const newRRRDetails = {
          rrr: response.rrr || rrr,
          merchantId: response.merchantId || merchantId,
          hash: response.hash || hash,
          billerUrl: response.billerUrl || billerUrl,
          responseUrl: response.responseUrl || responseUrl,
        };

        setRRRDetails(newRRRDetails); // ✅ Update state
        // ✅ Show success notification
        store.addNotification({
          title: "Success",
          message: "Invoice details fetched successfully!",
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 5000,
          },
        });
        searchInvoiceReference();
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        console.error("API Error Response:", response);

        // ✅ Show error notification
        store.addNotification({
          title: "Error",
          message: response || "An error occurred while generating RRR.",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 5000,
          },
        });

        dispatch(
          alertActions.error(response.message || "Error generating RRR")
        );
      }
    } catch (error) {
      console.error("generating RRR:", error);

      // ✅ Show error notification for unexpected errors
      store.addNotification({
        title: "Error",
        message: "An unexpected error occurred while generating RRR",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 5000,
        },
      });

      dispatch(alertActions.error("Error while generating RRR"));
    } finally {
      setIsLoading(false);
    }
  };

  const handlePaymentPaystack = async () => {
    if (!selectedGateway || selectedGateway.paymentGateway !== "Paystack") {
      store.addNotification({
        title: "Paystack",
        message: "Please select Paystack as a payment option to continue.",
        type: "warning",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 5000 },
      });
      return;
    }
  
    const payload = {
      invNum: invoiceLocal || invoiceNumber,
      agencyId,
    };
  
    setIsLoading(true);
    dispatch(alertActions.startRequest());
  
    try {
      const res = await externalPaymentService.handlePaymentPaystack(payload);
      dispatch(alertActions.stopRequest());
  
      const response = res.response;
  
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        const gw = Array.isArray(response?.revenuePaymentGateway)
          ? response.revenuePaymentGateway[0]
          : null;
  
        const billerUrl = gw?.billerUrl;
        const responseUrl = gw?.responseUrl;
  
        if (billerUrl) {
          // ✅ Store responseUrl in localStorage so we know where to return
          localStorage.setItem("Paystack_ResponseUrl", responseUrl);
          localStorage.setItem("Paystack_InvoiceNumber", invoiceLocal || invoiceNumber);
  
          store.addNotification({
            title: "Success",
            message: "Redirecting to Paystack...",
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 3000 },
          });
  
          // ✅ Redirect to Paystack checkout
          // Paystack will redirect back to responseUrl after payment
          window.location.href = billerUrl;
        } else {
          store.addNotification({
            title: "Error",
            message: "Payment link was not returned. Please try again.",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 5000 },
          });
        }
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        console.error("API Error Response:", response);
  
        store.addNotification({
          title: "Error",
          message:
            response || "An error occurred while initiating Paystack payment.",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 5000 },
        });
  
        dispatch(
          alertActions.error(
            response?.message || "Error initiating Paystack payment"
          )
        );
      }
    } catch (error) {
      console.error("initiating Paystack:", error);
  
      store.addNotification({
        title: "Error",
        message:
          "An unexpected error occurred while initiating Paystack payment.",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 5000 },
      });
  
      dispatch(alertActions.error("Error while initiating Paystack payment"));
    } finally {
      setIsLoading(false);
    }
  };

  const handleRevopsPayment = async () => {
    if (!selectedGateway || selectedGateway.paymentGateway.toLowerCase() !== "revops") {
      store.addNotification({
        title: "RevOps",
        message: "Please select RevOps as a payment option to continue.",
        type: "warning",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 5000 },
      });
      return;
    }

    const payload = {
      invNum: invoiceLocal || invoiceNumber,
      agencyId,
    };

    setIsLoading(true);
    dispatch(alertActions.startRequest());

    try {
      const res = await externalPaymentService.handleRevopsPayment(payload);
      dispatch(alertActions.stopRequest());

      const response = res.response;

      if (res.status === appConstants.SUCCESS_RESPONSE) {
        const availableGateways = Array.isArray(response?.revenuePaymentGateway)
          ? response.revenuePaymentGateway
          : [];
        const revopsGateway =
          availableGateways.find(
            (gateway) =>
              String(gateway?.revenuePaymentGatewayId) ===
                String(selectedGateway.revenuePaymentGatewayId) ||
              String(gateway?.paymentGateway || "").toLowerCase() === "revops"
          ) || (availableGateways.length === 1 ? availableGateways[0] : null);

        const paymentUrl = revopsGateway?.billerUrl;
        const revopsResponseUrl = revopsGateway?.responseUrl;

        if (paymentUrl) {
          if (revopsResponseUrl) {
            localStorage.setItem("RevOps_ResponseUrl", revopsResponseUrl);
          }
          localStorage.setItem(
            "RevOps_InvoiceNumber",
            invoiceLocal || invoiceNumber
          );

          store.addNotification({
            title: "Success",
            message: "Redirecting to RevOps...",
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 3000 },
          });

          window.location.href = paymentUrl;
        } else {
          store.addNotification({
            title: "Error",
            message: "RevOps payment link was not returned. Please try again.",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 5000 },
          });
        }
      } else {
        store.addNotification({
          title: "Error",
          message:
            response?.message ||
            response ||
            "An error occurred while initiating RevOps payment.",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 5000 },
        });

        dispatch(
          alertActions.error(
            response?.message || "Error initiating RevOps payment"
          )
        );
      }
    } catch (error) {
      console.error("initiating RevOps:", error);

      store.addNotification({
        title: "Error",
        message: "An unexpected error occurred while initiating RevOps payment.",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 5000 },
      });

      dispatch(alertActions.error("Error while initiating RevOps payment"));
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetRRR = async () => {
    await searchInvoiceRRR(amount); // Wait for searchInvoiceRRR to complete
  };

  const handlePartPaymentClick = () => {
    setIsModalOpen(true);
  };

  const submitRemitaForm = () => {
    if (formRef.current) {
      // Set form values dynamically
      formRef.current.merchantId.value = merchantId;
      formRef.current.hash.value = hash;
      formRef.current.rrr.value = rrr;
      formRef.current.responseurl.value = responseUrl;

      // Set the form action URL correctly
      formRef.current.action = billerUrl;
      // formRef.current.action = "https://login.remita.net/remita/ecomm/finalize.reg"

      // Ensure form submission happens in a user-triggered event
      setTimeout(() => {
        formRef.current.submit();
      }, 500);
    }
  };


  // Use useEffect to trigger form submission when rrrDetails is updated

  const handleFullPaymentClick = async () => {
    if (!rrr) {
      try {
        const newRRRDetails = await handleGetRRR();
        if (newRRRDetails && newRRRDetails.rrr) {
          setRRRDetails(newRRRDetails);
          setIsPaymentModal(true);
        }
        // Remove the else block here, as error handling is done in searchInvoiceRRR
      } catch (error) {
        console.error("Error in handleFullPaymentClick:", error);
        // We'll let the error handling in searchInvoiceRRR take care of notifications
      }
    } else {
      // If RRR exists, proceed with payment submission
      submitRemitaForm({
        MerchantId: merchantId,
        Hash: hash,
        RRR: rrr,
        ResponseUrl: responseUrl,
      });
    }
  };
  useEffect(() => {
    if (rrrDetails && !rrr) {
      submitRemitaForm(rrrDetails); // Submit the form with the new RRR details
    }
  }, [rrrDetails]);

  const formatCurrency = (amount = 0) => {
    // Create Intl.NumberFormat object with Nigerian currency format
    const formatter = new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
      minimumFractionDigits: 2,
    });

    // Format the currency
    return formatter.format(amount);
  };
  const handleGatewaySelect = (gatewayId) => {
    setSelectedGatewayId((prev) => (prev === gatewayId ? null : gatewayId));
  };

  const selectedPaymentGateway = selectedGateway?.paymentGateway?.toLowerCase();
  const isRemitaGateway = selectedPaymentGateway === "remita";
  const isRevopsGateway = selectedPaymentGateway === "revops";

  const shouldShowPaySection =
    !disableRevenuePayment &&
    (status === "Unpaid" || status === "Partial Payment");

  return (
    <div className="invoice-container">
      <button className="go-back" onClick={() => window.location.reload()}>
        ← Go back
      </button>

      <Row>
        <Col md={6}>
          <h2 className="invoice-title">Invoice details</h2>
        </Col>
        <Col md={6} style={{ textAlign: "right" }}>
          <div className="first-row">
            <h1
              style={{
                fontSize: "13px",
                fontWeight: "400",
                color: "rgba(38, 38, 38, 0.80)",
                marginBottom: 0,
              }}
            >
              Invoice amount
            </h1>
            <p className="invoice-title">{formatCurrency(invoiceAmount)}</p>
          </div>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md="3">
          <span className="info-heading">Invoice number</span>
          <br />
          <span className="info-detail">{invoiceNumber}</span>
        </Col>
        <Col md="3">
          <span className="info-heading">Payment reference</span>
          <br />
          <span className="info-detail">{rrr}</span>
        </Col>
        <Col md="3">
          <span className="info-heading">Revenue</span>
          <br />
          <span className="info-detail">{revenue}</span>
        </Col>
        <Col md="3">
          <span className="info-heading">Agency name</span>
          <br />
          <span className="info-detail">{agencyName}</span>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md="3">
          <span className="info-heading">Location</span>
          <br />
          <span className="info-detail">{location}</span>
        </Col>
        <Col md="3">
          <span className="info-heading">Phone number</span>
          <br />
          <span className="info-detail">{phoneNumber}</span>
        </Col>
        <Col md="3">
          <span className="info-heading">Email</span>
          <br />
          <span className="info-detail">{email}</span>
        </Col>
        <Col md="3"></Col>
      </Row>

      <div className="payment-summary">
        <h3>Payment summary</h3>
        <Row className="mb-3">
          <Col md="4">
            <span className="info-heading">Invoice amount</span>
            <br />
            <span className="info-detail">{formatCurrency(invoiceAmount)}</span>
          </Col>
          <Col md="4">
            <span className="info-heading">Amount paid</span>
            <br />
            <span className="info-detail">{formatCurrency(amountPaid)}</span>
          </Col>
          <Col md="4">
            <span className="info-heading">Outstanding</span>
            <br />
            <span className="info-detail">{formatCurrency(outstanding)}</span>
          </Col>
        </Row>
      </div>

      {/* {status === "Unpaid" && deleted === false && ( */}
      {/* {(status === "Unpaid" || status === "Partial Payment") && ( */}
      {disableRevenuePayment ? (
        <div className="badge-invoice">
          Revenue not supported for payment on this platform
        </div>
      ) : (
        shouldShowPaySection && (
          <>
            {/* ✅ Pay with cards */}
            {gateways.length > 0 && (
              <div style={{ marginTop: 10 }}>
                <h3 style={{ marginBottom: 12 }}>Pay with</h3>

                <div className="pay-with-row">
                  {gateways.map((g) => (
                    <PaymentOptionCard
                      key={g.revenuePaymentGatewayId}
                      id={g.revenuePaymentGatewayId}
                      label={g.paymentGateway}
                      selected={selectedGatewayId === g.revenuePaymentGatewayId}
                      onSelect={handleGatewaySelect}
                      logoSrc={g.logoURL}
                    />
                  ))}
                </div>
              </div>
            )}

            {/* ✅ Buttons show ONLY after selection */}
            {isRemitaGateway && (
              <div className="button-row" style={{ marginTop: 18 }}>
                {enablePartialPayment && (
                  <button
                    style={{
                      width: "400px",
                      height: "40px",
                      paddingLeft: 20,
                      paddingRight: 20,
                      paddingTop: 10,
                      paddingBottom: 10,
                      borderRadius: "12px",
                      cursor: "pointer",
                      border: "1px solid #BFBFBF",
                      color: "#000000",
                    }}
                    onClick={handlePartPaymentClick}
                  >
                    Partial payment
                  </button>
                )}

                <button
                  style={{
                    width: enablePartialPayment ? "400px" : "100%",
                    height: "40px",
                    paddingLeft: 20,
                    paddingRight: 20,
                    paddingTop: 10,
                    paddingBottom: 10,
                    borderRadius: "12px",
                    cursor: "pointer",
                    background: "#1F1F1F",
                    color: "#fff",
                  }}
                  onClick={handleFullPaymentClick}
                  disabled={isLoading}
                >
                  {isLoading ? "Processing..." : "Full payment"}
                </button>
              </div>
            )}

            {isRevopsGateway && (
              <div className="button-row" style={{ marginTop: 18 }}>
                <button
                  style={{
                    width: "100%",
                    height: "48px",
                    paddingLeft: 20,
                    paddingRight: 20,
                    paddingTop: 10,
                    paddingBottom: 10,
                    borderRadius: "12px",
                    cursor: "pointer",
                    background: "#1F1F1F",
                    color: "#fff",
                  }}
                  onClick={handleRevopsPayment}
                  disabled={isLoading}
                >
                  {isLoading ? "Processing..." : "Full payment"}
                </button>
              </div>
            )}

            {selectedGateway?.paymentGateway === "Paystack" && (
              <div className="button-row" style={{ marginTop: 18 }}>
                <button
                  style={{
                    width: "100%",
                    height: "48px",
                    paddingLeft: 20,
                    paddingRight: 20,
                    paddingTop: 10,
                    paddingBottom: 10,
                    borderRadius: "12px",
                    cursor: "pointer",
                    background: "#1F1F1F",
                    color: "#fff",
                  }}
                  onClick={handlePaymentPaystack}
                >
                 {isLoading ? "Processing..." : "Pay now"}
                </button>
              </div>
            )}

            {/* ✅ Optional: nudge user if no selection yet */}
            {!selectedGateway && gateways.length > 0 && (
              <div style={{ marginTop: 12, color: "rgba(31,31,31,0.7)" }}>
                Select a payment option to continue.
              </div>
            )}
          </>
        )
      )}

      {paymentHistory && paymentHistory.length > 0 && (
        <div style={{ marginTop: "15%" }}>
          <h3>Payment History</h3>
          <PaymentHistoryTable
            apiData={paymentHistory}
            formatCurrency={formatCurrency}
          />
        </div>
      )}

      {
        <PartPaymentModal
          isOpen={isModalOpen}
          toggle={() => setIsModalOpen(!isModalOpen)}
          outstandingAmount={outstanding}
          agencyId={agencyId} // ✅ Pass agencyId
          numberOfPayment={numberOfPayment}
          minimumPartPayment={minimumPartPayment}
          percentagePartPayment={percentagePartPayment}
          formatCurrency={formatCurrency}
          searchInvoiceReference={searchInvoiceReference}
        />
      }

      {rrrDetails && (
        <PaymentSummary
          isOpen={isPaymentModal}
          toggle={() => setIsPaymentModal(!isPaymentModal)}
          outstandingAmount={outstanding}
          amountToPay={amount}
          rrr={rrrDetails.rrr}
          agencyId={agencyId}
          billerUrl={billerUrl}
          merchantId={rrrDetails.merchantId || merchantId}
          hash={rrrDetails.hash || hash}
          responseUrl={rrrDetails.responseUrl || responseUrl}
          formatCurrency={formatCurrency}
        />
      )}

      {/* Hidden Form for Remita Payment */}
      <form
        ref={formRef}
        action=""
        name="SubmitRemitaForm"
        method="POST"
        target="_blank"
        style={{ display: "none" }}
      >
        <input name="merchantId" type="hidden" />
        <input name="hash" type="hidden" />
        <input name="rrr" type="hidden" />
        <input name="responseurl" type="hidden" />
        <input type="submit" value="Pay via Remita" />
      </form>
    </div>
  );
};

function mapStateToProps(state) {
  const { alert, user, requesting, userData, displayGeneralAlert } = state;
  return {
    alert,
    user,
    requesting,
    userData,
    displayGeneralAlert,
  };
}

export default connect(mapStateToProps)(InvoiceDetails);
